<template>
  <div class="classlayout">
    <el-main>
      <div class="div">
        <el-button
          type="primary"
          @click="addClass"
        >
          +&nbsp;新增
        </el-button>
      </div>
      <el-table
        :data="oneData"
        :height="height"
        v-loading="loading"
        header-row-class-name="header-row-class-name"
        :default-sort="{ prop: 'id', order: 'descending' }"
        border
        style="width: 100%"
      >
        <el-table-column prop="id" sortable label="ID号"> </el-table-column>
        <el-table-column prop="ordinal" sortable label="排序值"> </el-table-column>
        <el-table-column prop="name" label="类型名"> </el-table-column>
        <!-- <el-table-column prop="shortName" label="缩写"> </el-table-column> -->
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.used === true" style="color: #00ff00">
              启用
            </span>
            <span v-if="scope.row.used === false" style="color: #ff0000">
              禁用
            </span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="editClass(scope.row)"
            >
              编辑
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="dealOne(scope.row.id, false)"
              v-if="scope.row.used == true"
            >
              禁用
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="dealOne(scope.row.id, true)"
              v-if="scope.row.used == false"
            >
              启用
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 编辑框 -->
      <edit-dialog
        v-model="classDialogVisible"
        :rowData="rowData"
        dialogName="type"
        :dialogType="dialogType"
        @success="editSuccess"
      >
      </edit-dialog>
    </el-main>
  </div>
</template>
<script type="text/babel">
import editDialog from "./edit-dialog";
import commonService from "@/service/commonService";
export default {
  components: {
    editDialog: editDialog,
  },
  name: "commonLevelOne",
  data() {
    return {
      rowData: {},
      height: this.SysConstant.winHeight - 280,
      classDialogVisible: false,
      oneData: [],
      loading: false,
      dialogType: 'add'
    };
  },
  async mounted() {
    // 查询
    await this.getOne();
  },
  methods: {
    async getOne() {
      this.loading = true;
      try {
        let data = await commonService.common_tag_get('one');
        this.oneData = data || [];
      } catch (e) {
        this.$message.error(e && e.msg);
      }
      this.loading = false;
    },
    // 启用和禁用
    async dealOne(id, used) {
      let typeName = used ? '启用': '禁用';
      this.$confirm(`此操作将该${typeName}试卷类型, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(async () => {
        await commonService.common_tag_deal('one', { id, used });
        this.$message.success(this.SysConstant.success);
        this.getOne();
      });
    },
    // 修改标签
    async setOne(params) {
      try {
        await commonService.common_tag_set('one', params);
        this.$message.success(this.SysConstant.success);
        this.classDialogVisible = false;
        this.getOne();
      } catch (e) {
        this.$message.error(e && e.msg);
      }
    },
    addClass() {
      this.rowData = {
        name: '',
        ordinal: ''
      };
      this.dialogType = 'add';
      this.classDialogVisible = true;
    },
    editClass(row) {
      this.rowData = row;
      this.dialogType = 'edit';
      this.classDialogVisible = true;
    },
    editSuccess(data) {
      this.setOne(data);
    },
  },
};
</script>
<style scoped>
.classlayout .div {
  background-color: #ffffff;
  color: #333;
  line-height: 60px;
  height: 60px;
  margin-top: -10px;
  margin-bottom: 5px;
}
.classlayout .div {
  margin-top: -10px;
}
.classlayout .div .el-button {
  background-color: #00aaff;
  color: #fff;

  margin: 10px;
  float: left;
}
.classlayout .div2 {
  overflow: hidden;
  background-color: #ffffff;
  color: #333;
  line-height: 60px;
  margin: 5px 0;
}
.classlayout .div2 span {
  margin: 0px 40px;
  float: left;
}
.classlayout .div2 .btn {
  float: left;
  width: 80%;
}
.classlayout .div2 .active {
  background-color: #00aaff;
  color: #fff;
}
</style>
<style type="text/css">
.classlayout .div2 .el-radio-button {
  margin: 10px 10px;
  border: none !important;
  border-radius: 4px !important;
}
.classlayout .el-radio-button__inner {
  border: 1px solid #dcdfe6;
}
</style>




// WEBPACK FOOTER //
// src/pages/layout/common-manage/levelone.vue